import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools } from '@fortawesome/free-solid-svg-icons';
export default function Symptom() {
    return (
        <h3>
            Coming Soon....
            <FontAwesomeIcon icon={faTools} />
        </h3>
    );
}
